export * from './collapse-wrapper.component';
